import {
  PORTALEXTERIOR_SUCCESS,
  PORTALEXTERIOR_LOADING,
  PORTALEXTERIOR_ERROR,
  PORTALEXTERIOR_RESET,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosPaciente from "global/helpers/axiosPaciente";

export const wsPostDniPortalPCR = (dni) => (dispatch) => {
  dispatch({
    type: PORTALEXTERIOR_LOADING,
  });
  axiosInstance().then(respuesta => {
  respuesta
  .post(`/paciente/altaWeb`, dni)
  .then((res) => {
    sessionStorage.token = res.data.token;
    dispatch({
      type: PORTALEXTERIOR_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: PORTALEXTERIOR_ERROR,
      payload: error,
    });
  });
 } )
};
export const portalExteriorReset = () => (dispatch) => {
  sessionStorage.token = null
  dispatch({
    type: PORTALEXTERIOR_RESET,
  });
}